import {Footer} from '@/domains/orga/Footer';
import {Navbar} from '@/components/Navbar/Navbar';
import {BottomNav} from '@/components/Navbar/BottomNav/BottomNav';
import {Box, HStack, Portal, VStack, useToast} from '@chakra-ui/react';
import {Outlet, useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import {ConsentementAnalytics} from '@/components/Analytics/ConsentementAnalytics';
import {SidePanelPanier} from '@/components/SidePanelPanier/SidePanelPanier';
import {useSidePanelPanier} from '@/components/SidePanelPanier/SidePanelPanierContext';
import {useSearch} from '@/components/Navbar/Searchbar/SearchContext';
import {SearchResults} from '@/components/Navbar/Searchbar/SearchResults';
import {SEARCH_MIN_CHARS} from 'ff-common';

export const Layout: React.FC = () => {
  const toast = useToast();
  const location = useLocation();
  const {isOpen: showSidePanel} = useSidePanelPanier();
  const {liveTerm} = useSearch(); // recupération du terme de recherche
  const isLiveSearchActive = liveTerm.length >= SEARCH_MIN_CHARS; // la recherche live est active si le terme a au moins le nombre minimum de caractères

  useEffect(() => {
    // fermeture de tous les toasts si on change de page
    toast.closeAll();
  }, [location, toast]);
  return (
    <>
      <VStack
        gap='0'
        minH='100vh'
        position='relative'
      >
        <Navbar />
        <HStack
          w='100%'
          flexGrow='1'
          alignItems='stretch'
          gap='0'
        >
          <Box
            position='relative'
            flex='1'
            minW='0'
            overflowX='clip'
          >
            {/* La recherche remplace le contenu ; en base la modale gère */}
            {isLiveSearchActive && (
              <Box display={{base: 'none', md: 'block'}}>
                <SearchResults />
              </Box>
            )}
            <Box
              display={
                isLiveSearchActive ? {base: 'block', md: 'none'} : undefined
              }
            >
              <Outlet />
            </Box>
          </Box>
          {showSidePanel && <SidePanelPanier />}
        </HStack>
        <Footer />
      </VStack>
      <Portal>
        <ConsentementAnalytics />
        <BottomNav />
      </Portal>
    </>
  );
};
